import React from 'react';
import { API } from '@gin-betting/core';

import { getTournamentCountryCode } from '../../../../utils';
import CategorizerCheckRow from '../../CategorizerCheckRow';

interface Props {
    items: API.CategorizerItem[];
    isAllItemsInSportChecked: boolean;
    isTournamentManuallyChecked: boolean;
    selectedTournamentIds: string[];
    hasSiblingSubgroups: boolean;
    onTournamentsChecked: (tournamentIds: string[]) => void;
}

const CheckRowList: React.FC<Props> = ({
    items,
    selectedTournamentIds,
    isAllItemsInSportChecked,
    hasSiblingSubgroups,
    isTournamentManuallyChecked,
    onTournamentsChecked,
}) => {
    const hasOnlyOneTournament = !hasSiblingSubgroups && items.length === 1;

    const isRowCheckable =
        !isAllItemsInSportChecked ||
        isTournamentManuallyChecked ||
        hasOnlyOneTournament;

    return (
        <React.Fragment>
            {items.map((child: API.CategorizerItem) => {
                const { name, value, count } = child;

                const isChecked =
                    isRowCheckable && selectedTournamentIds.includes(value);

                return (
                    <CategorizerCheckRow
                        key={value}
                        title={name}
                        id={value}
                        checked={isChecked}
                        onClick={onTournamentsChecked}
                        count={count}
                        countryCode={getTournamentCountryCode(child, true)}
                    />
                );
            })}
        </React.Fragment>
    );
};

export default CheckRowList;
